const MIN_PENDING_FILE_BYTES = 100 * 1024;
const MAX_PENDING_PROGRESS_PERCENT = 90;

function getFileCount(value) {
    if (!Number.isFinite(value) || value <= 0) {
        return 0;
    }

    return Math.floor(value);
}

function getByteCount(value) {
    if (!Number.isFinite(value) || value <= 0) {
        return 0;
    }

    return Math.floor(value);
}

function getClampedPercent(value) {
    if (!Number.isFinite(value)) {
        return 0;
    }

    return Math.min(100, Math.max(0, value));
}

export function formatBytes(bytes) {
    if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';

    const units = ['B', 'KB', 'MB', 'GB'];
    let value = bytes;
    let unitIndex = 0;

    while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex += 1;
    }

    return `${value.toFixed(value >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}

export function getProgressPercent({ progress, totalBytes } = {}) {
    if (!Number.isFinite(totalBytes) || totalBytes <= 0 || !Number.isFinite(progress)) {
        return 0;
    }

    return getClampedPercent(progress * 100);
}

export function getLoaderAggregateProgressPercent(progressMessage = {}) {
    const filesPending = getFileCount(progressMessage.filesPending);

    if (filesPending === 0) {
        return getProgressPercent(progressMessage);
    }

    const loadedBytes = getByteCount(progressMessage.loadedBytes);
    const totalBytes = getByteCount(progressMessage.totalBytes);
    const estimatedTotalBytes = Math.max(totalBytes, loadedBytes + (filesPending * MIN_PENDING_FILE_BYTES));
    const estimatedProgressPercent = estimatedTotalBytes > 0
        ? getClampedPercent((loadedBytes / estimatedTotalBytes) * 100)
        : getProgressPercent(progressMessage);

    return Math.min(MAX_PENDING_PROGRESS_PERCENT, estimatedProgressPercent);
}

export function getExpectedOrigin(url) {
    try {
        const { origin } = new URL(url, window.location.href);

        return origin === 'null' ? null : origin;
    } catch {
        return null;
    }
}
